module.exports = __webpack_public_path__ + "img/table-columns-solid.804f98eb.svg";